<template>
  <div
    id="modal_showApp"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
      style="max-width: 850px"
    >
      <div
        class="modal-content"
        style="border-style: dashed; border-width: 1px"
      >
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('modal_showApp')"
          >
            &times;
          </button>
        </div>
        <table
          style="width: 100%"
          id="head-table"
        >
          <tr>
            <td style="padding-left: 20px">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%; margin-left: 0px"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  <span v-if="detailData.action === 'cash back'">CashBack Invoice</span>
                  <span v-else>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Receipt
                  </span>
                </strong>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td id="info-section1">
                <!-- <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Branch:
                  <span style="font-weight: normal">{{ detailData.branch_name }}</span>
                </p> -->
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Invoice Number:
                  <span style="font-weight: normal">{{ detailData.invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.base_invoice_number != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  Credit Invoice Number:
                  <span style="font-weight: normal">{{ detailData.base_invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.credit_log_action_date != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  Invoice Date:
                  <span style="font-weight: normal">{{ detailData.credit_log_action_date }}</span>
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  Invoice Date:
                  <span style="font-weight: normal">{{ detailData.created_at }}</span>
                </p>
              </td>
              <td id="info-section2">
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Customer Name:
                  <span style="font-weight: normal">{{ detailData.customer_name }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Customer Address:
                  <span style="font-weight: normal">{{ detailData.customer_address }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Customer Tel:
                  <span style="font-weight: normal">{{ detailData.phone_number }}</span>
                </p>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table3"
          >
            <tr style="height: 120px">
              <td id="price-section00">
                <p style="font-size: 14px; font-weight: bold">Description</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  Note
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  Old Amount
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  New Amount
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold"
                >Amount</p>
              </td>
              <td id="price-section11">
                <p style="font-size: 14px; font-weight: normal">: {{ detailData.description }}</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : {{ detailData.note }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : ${{ detailData.old_price }}
                </p>
                <p style="font-size: 14px; font-weight: normal">: ${{ detailData.amount }}</p>
              </td>
            </tr>
          </table>

          <table style="width: 100%">
            <tr>
              <td style="text-align: right; padding-right: 10px; border: 1px solid #000">
                <p style="font-size: 14px; font-weight: bold">
                  Total:
                  <span style="font-weight: normal"><b>${{ detailData.amount }}</b></span>
                </p>
              </td>
            </tr>
          </table>

          <div style="float: right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height:auto"
              outline
              color="primary"
            >Print</v-btn>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detailData', 'closeModal', 'companyData'],

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
  },

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] })

      $('#close-button').show()
      $('#print-button').show()
    }
  }
}
</script>

<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logs/viewActionLog.vue